import { render, staticRenderFns } from "./Measure.vue?vue&type=template&id=5478c468&scoped=true"
import script from "./Measure.vue?vue&type=script&lang=js"
export * from "./Measure.vue?vue&type=script&lang=js"
import style0 from "./Measure.vue?vue&type=style&index=0&id=5478c468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-load_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478c468",
  null
  
)

export default component.exports